import { useSelector } from "react-redux";

import { cn } from "../../utils/ui";
import { ToastHeader } from "./components/ToastHeader";
import { useToastStore } from "./store/toast";

// Define the RootState type for the Redux selector
interface RootState {
  notification: {
    message: {
      content: string;
      type: string;
      isLoading?: boolean;
    } | null;
  };
}

export const PersistentToast = () => {
  const {
    isVisible,
    title,
    description,
    content,
    isExpanded,
    minimiseOnDismiss,
    toggleExpand,
    minimise,
    closeToast,
  } = useToastStore();

  // Check if the regular Toast component is visible
  const regularToast = useSelector((state: RootState) => state.notification.message);
  const isRegularToastVisible = Boolean(regularToast);

  if (!isVisible) {
    return null;
  }

  // Apply different bottom position when the regular toast is visible
  const positionClass = isRegularToastVisible ? "bottom-24" : "bottom-4";

  return (
    <div
      className={`fixed ${positionClass} right-4 z-50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0`}
    >
      <div className="relative w-max max-w-[calc(100vw-2rem)] rounded-lg border border-border bg-background p-4 text-foreground shadow-lg">
        <ToastHeader
          title={title}
          description={description}
          onDismiss={minimiseOnDismiss ? minimise : closeToast}
          dismissMode={minimiseOnDismiss ? "minimise" : "close"}
          isExpanded={isExpanded}
          onToggleExpand={toggleExpand}
        />

        <div className={cn("mt-4 flex-grow pt-4", !isExpanded && "hidden")}>
          {content}
        </div>
      </div>
    </div>
  );
};
